import { type LaunchDarklyOptions } from "@packsize/feature-flags";

export type Environment = "preprod" | "prod1" | "prod2" | "legacy-preprod" | "legacy-prod1" | "legacy-prod2" | string;

export const environment: Environment = import.meta.env?.VITE_APP_ENVIRONMENT;
export const auditTTL: number = environment === "prod2" || environment === "legacy-prod2" ? 14 : 30;
export const storagePrefix = "PackNet_";

export const applicationName = "PackNet";
export const applicationVersion: string = import.meta.env?.VITE_APP_VERSION ?? "unknown";
export const launchDarklyOptions: LaunchDarklyOptions = {
	clientSideId: import.meta.env?.VITE_LAUNCH_DARKLY_KEY,
	baseUrl: import.meta.env?.VITE_LAUNCH_DARKLY_BASE_URL,
	streamUrl: import.meta.env?.VITE_LAUNCH_DARKLY_STREAM_URL,
	eventsUrl: import.meta.env?.VITE_LAUNCH_DARKLY_EVENTS_URL,
};
export const applicationInsightsConnectionString: string =
	import.meta.env?.VITE_APPLICATION_INSIGHTS_CONNECTION_STRING ?? "";
export const checklyStatusUrl: string = import.meta.env?.VITE_CHECKLY_STATUS_URL ?? "";
export const companyUrl: string = import.meta.env?.VITE_COMPANY_URL ?? "";
